export default "__VITE_ASSET__wcIvQHA4__"